module.exports = __webpack_public_path__ + "img/teacher_multiple_teachers_emails_button.ee1783b3.jpg";